module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "be-signup"
  }, [_vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "splash-container"
  }, [_vm._c('div', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._m(0), _vm._v(" "), _vm._c('div', {
    staticClass: "panel-body"
  }, [_vm._c('span', {
    staticClass: "splash-title xs-pb-20"
  }, [_vm._v("Join our mailing list")]), _vm._v(" "), _vm._c('SubscribeForm', {
    staticClass: "sub"
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._c('hr', {
    staticStyle: {
      "margin": "40px 0px"
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "row text-center"
  }, [_vm._c('div', {
    staticClass: "col-xs-12"
  }, [_vm._c('p', [_vm._v("Looking to unsubscribe?")]), _vm._v(" "), _vm._c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": "/newsletter-unsubscribe"
    }
  }, [_vm._v("Unsubscribe")])], 1)])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "panel-heading"
  }, [_vm._c('img', {
    staticStyle: {
      "width": "102px"
    },
    attrs: {
      "src": "/static/img/logo.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15d2d4a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newsletter/Subscribe.vue
// module id = 625
// module chunks = 1